import { faTextWidth } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Card, FormControl, FormGroup } from "react-bootstrap"
import { getCustomerNoticeBag, setNoticeToRead } from "../store/api/CustomerApi";
import BihamtaTable from "../Components/BihamtaTable";
import { useDispatch } from "react-redux";
import { useEffect, useState } from "react";
import { ChatRightText, Check2Square, Link45deg } from "react-bootstrap-icons";
import ModalNewTicket from "../Common/ModalNewTicket";
import { downloadFile } from "../store/api/Services";
import { findLinkInText } from "../store/api/CommonFunctions";

const NoticeBoard = () => {
    const [ticketModal, setTicketModal] = useState({show:false});

    const dispatch = useDispatch();
    const tableColes = [
        { colTitle: "ردیف", colName: "RowNumber", justInMobile: true },
        { colTitle: "شماره اطلاعیه", colName: "ID", justInMobile: true, styleCondition: (row) => !row.IsRead ? { fontWeight: "bold" } : { fontWeight: "normal" } },
        { colTitle: "تاریخ اطلاعیه", colName: "PNoticeDate", justInMobile: true, styleCondition: (row) => !row.IsRead ? { fontWeight: "bold" } : { fontWeight: "normal" } },
        { colTitle: "موضوع اطلاعیه", colName: "NoticeSubject", justInMobile: false, styleCondition: (row) => !row.IsRead ? { fontWeight: "bold" } : { fontWeight: "normal" } },
        { colTitle: "شرح اطلاعیه", colName: "NoticeDesc", colType:"string", justInMobile: false, hasLink:true, styleCondition: (row) => !row.IsRead ? { fontWeight: "bold" } : { fontWeight: "normal" } }
    ]
    const tableRowButtons = [{
        title: "بررسی شد", type: "common", className: "group-Btn-smalll btn-primary", icon: <Check2Square color="green" className="rowBtn" size={18} />,
        onclick: (item) => { dispatch(setNoticeToRead(item.ID)) },
        tooltip:"بررسی شد",
        showCondition: (item) => !item.IsRead
    }, {
        title: "ثبت تیکت", tooltip:"ثبت تیکت", type: "common", className: "group-Btn-smalll btn-info", icon: <ChatRightText color="purple" className="rowBtn" size={18} />,  onclick:showModalTicket
    },
    {
        title: "پیوست", tooltip:"پیوست", type: "common", className: "group-Btn-smalll btn-info", icon: <Link45deg color="blue" className="rowBtn" size={18} />,  onclick:(row)=> downloadFile(row.ID,"Notice")
    }
];
    function showModalTicket(row)
    {
        setTicketModal({show:true, formAttachmentID: row.ID, formAttachmentType: "Ticket", defaultSubject:`پاسخ به: اطلاعیه شماره ${row.ID}`})
    }
    useEffect(() => {
        document.body.classList = "notMain";
        dispatch(getCustomerNoticeBag());
    }, [])
    return (
        <div className="container-fluid mt-2">
            <br />
            <Card>
                <Card.Header className="headerStyle" style={{ textAlign: "right" }}>
                    <FontAwesomeIcon icon={faTextWidth} size="lg" />&nbsp;
                    اطلاعیه های من
                </Card.Header>
                <Card.Body className="bodyStyle">
                    <ModalNewTicket popData={ticketModal} setPopData={setTicketModal}/>
                    <FormGroup className="col-md-2">
                        <select className="form-control" defaultValue={null} onChange={(e) => dispatch(getCustomerNoticeBag(e.target.value))}>
                            <option value={null}>وضعیت بررسی</option>
                            <option value={false}>بررسی نشده</option>
                            <option value={true}>بررسی شده</option>
                        </select>
                    </FormGroup>
                    <BihamtaTable columns={tableColes} rowButtons={tableRowButtons} searchMethod={() => dispatch(getCustomerNoticeBag())} reducerName="customerDataReducer" objectName="noticeBag" />
                </Card.Body>
            </Card>
        </div>
    )
}
export default NoticeBoard;